import { render, staticRenderFns } from "./IndustryInformation.vue?vue&type=template&id=4ade6df4&scoped=true&"
import script from "./IndustryInformation.vue?vue&type=script&lang=js&"
export * from "./IndustryInformation.vue?vue&type=script&lang=js&"
import style0 from "./IndustryInformation.vue?vue&type=style&index=0&id=4ade6df4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade6df4",
  null
  
)

export default component.exports